import { useState } from 'react';
import { type NavView } from '../components/Layout';
import { useT } from '../i18n';
// Issue #550: Page shell — remove wrapper proprio (max-w-3xl p-6
// duplicava o <main> do Layout) e padroniza o header da pagina.
import Page from '../components/Page';

// Issue #475: Distribuicao DF-e por NSU — estrutura pronta, mas GATED:
// a distribuicao exige certificado A1 configurado (tools autenticadas do
// MCP). Ainda nao existe endpoint de status de certificado nem a feature
// de custodia (spec SPEC-GESTAO-CERTIFICADOS-A1.md) — ate la, toda org
// esta "sem cert" e ve o empty-state com link para a aba Certificados.
function SefazDfe({ onNavigate }: { onNavigate?: (v: NavView) => void }) {
  const t = useT();
  const [nsu, setNsu] = useState('');

  return (
    <Page title={t('sefaz.dfe.title')}>
      {/* Estrutura da consulta (desabilitada enquanto gated) */}
      <div className="mb-6 flex items-end gap-3 opacity-60">
        <div className="flex-1">
          <label className="mb-1 block text-sm font-medium text-brand-600">
            {t('sefaz.dfe.nsuLabel')}
          </label>
          <input
            type="text"
            value={nsu}
            onChange={(e) => setNsu(e.target.value.replace(/\D/g, '').slice(0, 15))}
            placeholder="000000000000000"
            className="w-full rounded-lg border border-brand-200 px-4 py-2 font-mono text-sm"
            disabled
          />
        </div>
        <button
          disabled
          className="rounded-lg bg-brand-600 px-6 py-2 font-medium text-white disabled:cursor-not-allowed disabled:opacity-50"
        >
          {t('sefaz.statusPage.consult')}
        </button>
      </div>

      {/* Empty-state gated */}
      <div className="rounded-lg border border-brand-200 bg-brand-50 p-6 text-center">
        <p className="mb-2 font-semibold text-brand-800">{t('sefaz.gated.title')}</p>
        <p className="mb-4 text-sm text-brand-600">{t('sefaz.gated.body')}</p>
        <button
          onClick={() => onNavigate?.('sefaz-certs')}
          className="rounded-lg border border-brand-300 px-4 py-2 text-sm font-medium text-brand-600 hover:bg-white"
        >
          {t('sefaz.gated.cta')}
        </button>
      </div>
    </Page>
  );
}

export default SefazDfe;
